import React from "react";
import styled from "styled-components";
import ReactDataGrid from "@inovua/reactdatagrid-enterprise";

/** 캠페인 관리 및 대시보드에서 공통으로 사용하는 캠페인 목록 테이블. */
export default function CampaignListTable({
  selectedCampaignId,
  onCampaignSelect,
  minWidth = 0,
  ...gridProps
}) {
  return (
      <StyledCampaignGrid
          {...gridProps}
          $minWidth={minWidth}
          rowClassName={({data}) =>
              String(data?.campaignId) === String(selectedCampaignId)
                  ? "campaign-list-selected-row"
                  : undefined
          }
          onRowClick={({data}) => onCampaignSelect?.(data)}
      />
  );
}

const StyledCampaignGrid = styled(ReactDataGrid)`
  width: 100% !important;
  min-width: ${({$minWidth}) => typeof $minWidth === "number" ? `${$minWidth}px` : $minWidth};
  min-height: 164px !important;
  border: 1px solid #e7d8cc;
  border-radius: 12px;
  color: #3f4750;
  font-size: var(--font-size-body);

  .InovuaReactDataGrid__header,
  .InovuaReactDataGrid__column-header {
    background: linear-gradient(180deg, #fffaf6 0%, #fff4e9 100%);
  }

  .InovuaReactDataGrid__column-header {
    border-right-color: #ecdcd0;
    border-bottom: 2px solid #f0c5a3;
    color: #4b5158;
    font-size: var(--font-size-label);
    font-weight: 800;
    letter-spacing: -0.01em;
  }

  .InovuaReactDataGrid__row {
    border-bottom-color: #edf0f2;
    background: #fff;
    color: #4c545c;
    transition: background-color 140ms ease, box-shadow 140ms ease;
  }

  .InovuaReactDataGrid__row-even { background: #fcfcfd; }
  .InovuaReactDataGrid__row:hover {
    z-index: 1;
    background-color: #fff8f1;
    box-shadow: inset 3px 0 0 #f5811f;
  }

  .campaign-list-selected-row {
    z-index: 1;
    background: linear-gradient(90deg, #fff0e2 0%, #fff8f1 100%) !important;
    color: #343a40;
    box-shadow: inset 4px 0 0 #f5811f,
      inset 0 1px 0 rgba(245, 129, 31, 0.18),
      inset 0 -1px 0 rgba(245, 129, 31, 0.18);
  }

  .campaign-list-selected-row:hover {
    background: linear-gradient(90deg, #ffe9d4 0%, #fff4e9 100%) !important;
  }

  .campaign-list-selected-row .InovuaReactDataGrid__cell { font-weight: 600; }
  .InovuaReactDataGrid__cell {
    padding-right: 14px;
    padding-left: 14px;
    border-right-color: #edf0f2;
  }
  .InovuaReactDataGrid__cell a { color: #b95b0b; font-weight: 700; text-decoration: none; }
  .InovuaReactDataGrid__cell a:hover { color: #e36f0d; text-decoration: underline; text-underline-offset: 3px; }
  .InovuaReactDataGrid__cell--active,
  .InovuaReactDataGrid__cell--selected {
    background: rgba(245, 129, 31, 0.06) !important;
    box-shadow: inset 0 0 0 1px rgba(245, 129, 31, 0.3);
  }
`;
